import { ChartCanvas } from "@/components/analytics/ChartCanvas";
import { ReadOnlyTable } from "@/components/ui/read-only-table";
import type { CreanceByParty } from "@/lib/reporting.api";
import { creanceColumns } from "../creanceColumns";
import { useCreancesByPartyChartConfig } from "../hooks/useCreancesByPartyChartConfig";

export function CreancesByPartySection({ creances }: { creances: CreanceByParty[] }) {
  const { topCreances, chartConfig } = useCreancesByPartyChartConfig(creances);

  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card">
      <div className="border-b border-border px-4 py-2.5">
        <p className="text-[11.5px] font-semibold text-body">Qui doit - créances par partie</p>
        <p className="text-[10.5px] text-muted-foreground">
          Toutes créances non réglées, indépendant de la période - situation actuelle.
        </p>
      </div>
      {creances.length === 0 ? (
        <p className="px-4 py-8 text-center text-[11.5px] text-muted-foreground">
          Aucune créance en cours.
        </p>
      ) : (
        <>
          <div className="border-b border-border p-4">
            <ChartCanvas
              label="Créances par partie"
              height={Math.max(180, topCreances.length * 34)}
              config={chartConfig}
            />
          </div>
          <ReadOnlyTable columns={creanceColumns} data={creances} bare />
        </>
      )}
    </div>
  );
}
